import React, { useState, useEffect } from "react";
import { makeRequest } from "../../../utils/makeRequest";
import { getPrivacyPolicyURL } from "../../../utils/urls";

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchPolicy = async () => {
        try {
            const response = await makeRequest(`${getPrivacyPolicyURL}`, 'GET');
            console.log("Policy response", response);

            if (response.success && response.data?.policy?.content) {
                setPolicy(response.data.policy.content);
            } else {
                setPolicy("Unable to load privacy policy at this time.");
            }
        } catch (error) {
            console.error("Error fetching privacy policy:", error);
            setPolicy("An error occurred while fetching the privacy policy.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPolicy();
    }, []);

    return (
        <div>
            <nav className="navbar navbar-light bg-light shadow-sm px-3">
                <div className="container d-flex align-items-center justify-content-between">
                    <a className="navbar-brand fw-bold" href="/">Payserve</a>
                    <div>
                        <a className="mx-3 text-decoration-none text-dark fw-bold" href="/">Home</a>
                        <a className="text-decoration-none text-dark fw-bold" href="/privacy_policy">Privacy Policy</a>
                    </div>
                    <div className="invisible navbar-brand"></div>
                </div>
            </nav>

            <div className="container my-5" style={{ minHeight: "75vh", maxWidth: "95%" }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-11 col-sm-12">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h3 className="mb-4 text-center fw-bold text-primary">
                                    Privacy Policy
                                </h3>

                                {loading ? (
                                    <p className="text-center text-muted">Loading privacy policy...</p>
                                ) : (
                                    <div
                                        className="text-muted"
                                        style={{
                                            lineHeight: "1.8",
                                            fontSize: "15px",
                                        }}
                                        dangerouslySetInnerHTML={{ __html: policy }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
